import { refreshSession } from './refreshSession'

// Shares one in-flight refresh with the 401 interceptor: concurrent refreshes
// trip Auth0's rotation reuse detection and revoke the whole token family.
const isLogged = async () => {
  try {
    await refreshSession()
    return true
  } catch (e) {
    return false
  }
}

export default isLogged
